// src/hooks/useSettingsLoader.ts
// Fetches public settings once on app load and populates the Zustand store.

import { useQuery } from '@tanstack/react-query';
import { settingsService } from '../api/services';
import { useSettingsStore } from '../features/settings/settings.store';

export function useSettingsLoader() {
  const loaded = useSettingsStore((s) => s.loaded);
  const load = useSettingsStore((s) => s.load);

  return useQuery({
    queryKey: ['settings', 'public'],
    queryFn: async () => {
      const data = await settingsService.getPublic();
      load(data);
      return data;
    },
    staleTime: Infinity,
    enabled: !loaded,
  });
}
